import initializeSIGSDataAction from '../actions/initializeSIGSDataAction';
import { FeatureNames } from 'owa-mail-smart-pill-features';
import { ClientItem } from 'owa-mail-store';
import { ArbitratedSmartPills, SmartPillData } from 'owa-smart-pill';

export default function initializeSIGSData(
    item: ClientItem,
    smartPillData: ArbitratedSmartPills
): void {
    // Note that we only log the smart reply (with text) extraction ID.
    // All other computations occur regardless of whether smart replies (with text) are present or not.
    const smartReplyPills: SmartPillData[] = !!smartPillData
        ? smartPillData.pillsToShow.filter(pill => pill.featureName === FeatureNames.SmartReply)
        : [];

    const extractionId: string =
        smartReplyPills.length > 0 ? smartReplyPills[0].logData.mainPayload.EID : '';

    const isSmartSuggestionsRendered: string =
        !!smartPillData && smartPillData.pillsToShow.length > 0 ? 'True' : 'False';

    const suggestionTypesRendered: string =
        isSmartSuggestionsRendered === 'True'
            ? smartPillData.pillsToShow.map(pill => pill.featureName).toString()
            : '';

    const suggestionsRendered: string =
        isSmartSuggestionsRendered === 'True'
            ? smartPillData.pillsToShow.map(pill => pill.text).join('$')
            : '';

    initializeSIGSDataAction(
        item.ItemId.Id,
        isSmartSuggestionsRendered,
        suggestionTypesRendered,
        suggestionsRendered,
        extractionId
    );
}
